import type { IDatasetScanOption } from '$shared/interfaces/api/IDatasetScanOption';

export class ScanOption {
  parameterSetId: string;
  referenceId: string;

  public static fromScanResponse(options: IDatasetScanOption): ScanOption {
    const scanOption = new ScanOption();
    scanOption.parameterSetId = options.parameterSetId;
    scanOption.referenceId = options.referenceId;
    return scanOption;
  }

  public static fromMonitorResponse(options: IDatasetScanOption): ScanOption {
    const scanOption = new ScanOption();
    scanOption.parameterSetId = options.parameterSetId!;
    scanOption.referenceId = options.referenceId;
    return scanOption;
  }
}
